<template>
  <div>
    <b-card>
      <b-table
        sticky-header
        id="ScheduleTable"
        :items="ScheduleArray"
        :fields="fields"
        no-border-collapse
        hover
        show-empty
        empty-text="There is nothing currently scheduled for this location"
        responsive
        small
      >
        <template v-slot:cell(Edit)="{ item }">
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="showeditAppointment(item)"
          >
            <BIconPencilSquare> </BIconPencilSquare>
          </b-button>
        </template>
        <template v-slot:cell(Delete)="{ item }">
          <b-button
            variant="outline-danger"
            size="sm"
            v-on:click="showdeleteAppointment(item)"
          >
            <BIconXSquare> </BIconXSquare>
          </b-button>
        </template>
      </b-table>
      <!-- <b-row>
        <b-col>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="showaddAppointment()"
          >
            <BIconPlusSquare></BIconPlusSquare> Add new Appointment
          </b-button>
        </b-col>
      </b-row> -->
    </b-card>
    <b-modal
      ref="addappointmentmodal"
      id="addappointmentmodal"
      title="Add Appointment"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card
        header-bg-variant="dark"
        header-text-variant="light"
        border-variant="light"
        bg-variant="light"
      >
        <template #header>
          <h6>New Appointment Form</h6>
        </template>
        <b-row>
          <b-col><h5 class="accessoriesHeader">Appointment Type</h5></b-col>
        </b-row>
        <b-row>
          <b-col
            ><b-form-select
              :options="AppointmentTypes"
              v-model="AppointmentType"
            ></b-form-select
          ></b-col>
        </b-row>
        <hr />
        <div v-if="AppointmentType == 'Water Testing'">
          <h5 class="accessoriesHeader">Water Testing</h5>
          <b-row>
            <b-col>
              <b-form-select
                :options="TestType"
                v-model="newBooking.TestType"
              ></b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-select
                id="input-3"
                v-model="newBooking.Type"
                :options="tests"
                required
              ></b-form-select>
            </b-col>
          </b-row>
        </div>
        <div v-if="AppointmentType == 'Manual Temp Check'">
          <h5 class="accessoriesHeader">Manual Temperature Checks</h5>
          <b-row>
            <b-col>
              <h5 class="accessoriesHeader">Number of Outlets</h5>

              <b-form-input
                id="LocationNote"
                v-model="newBooking.NoOfOutlets"
                placeholder="No of Outlets"
                required
                type="number"
              ></b-form-input> </b-col
          ></b-row>
        </div>
        <div v-if="AppointmentType == 'Risk Assessment'">
          <h5 class="accessoriesHeader">Risk Assessment</h5>
          <b-row>
            <b-col>
              <b-form-select
                id="input-3"
                v-model="newBooking.Type"
                :options="riskassessments"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-select :options="AssType" v-model="newBooking.CheckType">
              </b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-col v-if="newBooking.CheckType == 'Single Outlet'">
            <h5 class="accessoriesHeader">Outlet ID</h5>
            <b-form-input
              id="OutletID"
              v-model="newBooking.OutletID"
              placeholder="OutletID"
              required
            ></b-form-input>
          </b-col>
        </div>
        <div
          v-if="
            AppointmentType == 'Shower Head Installation' ||
              AppointmentType == 'Filter Installation'
          "
        >
          <h5
            class="accessoriesHeader"
            v-if="AppointmentType == 'Shower Head Installation'"
          >
            Shower Head Intallation
          </h5>
          <h5
            class="accessoriesHeader"
            v-if="AppointmentType == 'Filter Installation'"
          >
            Filter Installation
          </h5>
          <b-row v-if="AppointmentType == 'Filter Installation'">
            <b-col>
              <b-form-select
                :options="filters"
                v-model="newBooking.TestType"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="AppointmentType == 'Shower Head Installation'">
            <b-col>
              <b-form-select
                :options="showers"
                v-model="newBooking.TestType"
              ></b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <h5 class="accessoriesHeader">Number of Outlets</h5>

              <b-form-input
                id="LocationNote"
                v-model="newBooking.NoOfOutlets"
                placeholder="No of Outlets"
                required
                type="number"
              ></b-form-input> </b-col
          ></b-row>
        </div>
        <div
          v-if="
            AppointmentType == 'C-1 Service' ||
              AppointmentType == 'C-1 Incident' ||
              AppointmentType == 'O-1 Service' ||
              AppointmentType == 'O-1 Incident'
          "
        >
          <h5
            class="accessoriesHeader"
            v-if="
              AppointmentType == 'C-1 Service' ||
                AppointmentType == 'C-1 Incident'
            "
          >
            Clarence C-1
          </h5>
          <h5
            class="accessoriesHeader"
            v-if="
              AppointmentType == 'O-1 Service' ||
                AppointmentType == 'O-1 Incident'
            "
          >
            Clarence O-1
          </h5>
          <b-row
            v-if="
              AppointmentType == 'C-1 Service' ||
                AppointmentType == 'C-1 Incident'
            "
          >
            <b-col>
              <b-form-select
                id="input-3"
                v-model="newBooking.Type"
                :options="c1options"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row
            v-if="
              AppointmentType == 'O-1 Service' ||
                AppointmentType == 'O-1 Incident'
            "
          >
            <b-col>
              <b-form-select
                id="input-3"
                v-model="newBooking.Type"
                :options="o1options"
                required
              ></b-form-select>
            </b-col>
          </b-row>
        </div>
        <div
          v-if="
            AppointmentType == 'Washbasin Service' ||
              AppointmentType == 'Washbasin Incident'
          "
        >
          <h5 class="accessoriesHeader">Washbasin</h5>
          <b-row>
            <b-col>
              <b-form-select
                id="input-3"
                v-model="newBooking.Type"
                :options="basinoptions"
                required
              ></b-form-select>
            </b-col>
          </b-row>
        </div>

        <hr />
        <h5 class="accessoriesHeader">Location Information</h5>
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Room/Area</h5>
            <b-form-input
              id="Area"
              v-model="newBooking.Room"
              placeholder="Room/Area"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Location Note</h5>
            <b-form-input
              id="LocationNote"
              v-model="newBooking.Note"
              placeholder="Location Note"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Date</h5>
            <b-form-datepicker
              id="input-4"
              v-model="newBooking.Date"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Time</h5>

            <b-form-timepicker
              locale="en"
              v-model="newBooking.Time"
            ></b-form-timepicker>
          </b-col>
        </b-row>
        <hr />
        <h5 class="accessoriesHeader">Contact Information</h5>
        <b-row>
          <b-col>
            <b-form-input
              id="input-2"
              v-model="newBooking.Name"
              placeholder="Enter name"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-input
              placeholder="Email Address"
              v-model="newBooking.Email"
            ></b-form-input>
          </b-col>
        </b-row>

        <template #footer>
          <b-row>
            <b-col>
              <b-button
                variant="outline-info"
                v-on:click="saveNewAppointment()"
              >
                Submit
              </b-button>
            </b-col>
            <b-col>
              <b-button
                variant="outline-info"
                v-on:click="clearNewAppointment()"
              >
                Clear
              </b-button>
            </b-col>
            <b-col>
              <b-button
                variant="outline-info"
                v-on:click="cancelNewAppointment()"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-modal>
    <b-modal
      ref="modifyappointmentmodal"
      id="modifyappointmentmodal"
      title="Modify Appointment"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        footer-tag="footer"
      >
        <template #header>
          <h4 class="#">Modify Appointment Form</h4>
        </template>

        <b-card>
          <b-row
            ><b-col
              ><h3>{{ Action }}</h3></b-col
            ></b-row
          >
          <b-row class="mt-2">
            <b-col cols="4" class="modify-text-left">Service ID</b-col>

            <b-col cols="8">
              {{ ModifiedBooking.ServiceID }}
            </b-col>
          </b-row>
          <b-row class="mt-2"
            ><b-col cols="4" class="modify-text-left">Check Location</b-col>
            <b-col cols="8">
              {{ this.selectedlocation }}
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Type</b-col>
            <b-col cols="8">{{ ModifiedBooking.Type }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Category</b-col>
            <b-col cols="8">{{ ModifiedBooking.Category }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Service Note</b-col>
            <b-col cols="8">{{ ModifiedBooking.ServiceNote }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Room/Area</b-col>
            <b-col cols="8">{{ ModifiedBooking.Area }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Location Note</b-col>
            <b-col cols="8">{{ ModifiedBooking.LocationNote }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Arranged By</b-col>
            <b-col cols="8">{{ ModifiedBooking.ArrangedBy }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left"> Scheduled Date</b-col>
            <b-col cols="8">{{ ModifiedBooking.Date }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="modify-text-left">Scheduled Time</b-col>
            <b-col cols="8">{{ ModifiedBooking.Time }}</b-col>
          </b-row>
        </b-card>
        <br />

        <br />
        <b-row>
          <b-col>
            <b-button
              v-if="Action == 'Edit'"
              variant="outline-info"
              v-on:click="saveEditAppointment()"
            >
              Submit
            </b-button>
            <b-button
              v-if="Action == 'Delete'"
              variant="outline-danger"
              v-on:click="deleteAppointment(ModifiedBooking.ServiceID)"
            >
              Delete
            </b-button>
          </b-col>
          <b-col>
            <b-button
              variant="outline-info"
              v-on:click="cancelEditAppointment()"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import {
  // BIconPlusSquare,
  BIconPencilSquare,
  BIconXSquare,
} from "bootstrap-vue";

export default {
  components: {
    // BIconPlusSquare,
    BIconPencilSquare,
    BIconXSquare,
  },
  computed: {},
  data() {
    return {
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserURN: this.$UserURN,
      ScheduleArray: [
        // {
        //   0: "16757635",
        //   1: "WMS",
        //   2: "Risk Assessment",
        //   3: "New Booking",
        //   4: "Room 2 Maternity",
        //   5: "Back Sink",
        //   6: "Joanna Daly",
        //   7: "19/05/2023",
        //   8: "13:00:00",
        // },
      ],
      fields: [
        // {
        //   key: "0",
        //   label: "Service ID",
        //   stickyColumn: true,
        //   variant: "primary",
        // },
        // { key: "1", label: "Type" },
        // { key: "2", label: "Category" },
        // { key: "3", label: "Service Note" },
        // { key: "4", label: "Room/Area" },
        // { key: "5", label: " Location Note" },
        // { key: "6", label: "Arranged By" },
        // { key: "7", label: "Scheduled Date" },
        // { key: "8", label: "Scheduled Time" },
      ],

      Action: "",
      newBooking: {
        Room: null,
        Note: null,
        CheckType: null,
        Name: null,
        Type: null,
        Date: null,
        Email: null,
        TestType: null,
        NoOfOutlets: null,
        Category: null,
      },
      ModifiedBooking: {
        Area: null,
        Description: null,
        Type: null,
        ArrangedBy: null,
        Date: null,
        Time: null,
        Location: null,
        ServiceID: null,
      },
      AppointmentTypes: [
        { text: "Select Apppointment Type", value: null, disabled: true },
        "C-1 Incident",
        "C-1 Service",
        "Filter Installation",
        "Manual Temp Check",
        "O-1 Incident",
        "O-1 Service",
        "Risk Assessment",
        "Shower Head Installation",
        "Washbasin Incident",
        "Washbasin Service",
        "Water Testing",
      ],
      AppointmentType: null,
      tests: [
        { text: "Select Test Type", value: null, disabled: true },
        "Full Test",
        "Legionella Only",
        "Pseudomonas Only",
        "Other",
      ],
      TestType: [
        { text: "Colony or Rapid", value: null, disabled: true },
        "Colony Water Test",
        "Rapid Water Test",
      ],
      AssType: [
        { text: "Single or Full room", value: null, disabled: true },
        { text: "Full Room Assessment", value: "Full Room" },
        { text: "Single Outlet", value: "Single Outlet" },
      ],
      riskassessments: [
        { text: "Select Assessment Type", value: null, disabled: true },
        "Full Assessment",
        "Scald Assessment",
        "TMV Assessment",
        "Other Assessment",
      ],
      filters: [
        { text: "Install Type", value: null, disabled: true },
        "30 Day Inline",
        "30 Day Point of Use",
        "90 Day Inline",
      ],
      showers: [
        { text: "Install Type", value: null, disabled: true },
        { text: "Shower Pack Install", value: "Shower Pack Install" },
        { text: "Shower Head Only Install", value: "Shower Head Install" },
        { text: "Shower Hose Only Install", value: "Shower Hose Install" },
      ],
      c1options: [
        { text: "C-1 Actions", value: null, disabled: true },
        { text: "Annual Service", value: "Annual Service" },
        { text: "Hardware Malfunction", value: "Hardware Malfunction" },
        { text: "Biofilm Sensor", value: "Biofilm Sensor" },
        { text: "Other", value: "Other" },
      ],
      o1options: [
        { text: "O-1 Actions", value: null, disabled: true },
        { text: "Annual Service", value: "Annual Service" },
        { text: "Hardware Malfunction", value: "Hardware Malfunction" },
        { text: "Battery Replacement", value: "Battery Replacement" },
        { text: "Other", value: "Other" },
      ],
      basinoptions: [
        { text: "Washbasin Actions", value: null, disabled: true },
        { text: "Annual Service", value: "Annual Service" },
        { text: "Hardware Malfunction", value: "Hardware Malfunction" },
        { text: "Biofilm Sensor", value: "Biofilm Sensor" },
        { text: "Chemical Replacement", value: "Chemical Replacement" },
        { text: "Filter Change", value: "Filter Change" },
        { text: "Other", value: "Other" },
      ],
    };
  },
  mounted() {
    //  this.SubmitUserURN = this.$UserURN;
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/service";
    let LookUpHeaders = this.$apikeyPost;

    this.LookUpRequest = {
      RequestType: "LoadAllLocation",
      RequestVariable: this.selectedlocation,
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        response;

        let data = response.data.Values;
        for (let i = 0; i < response.data.Values.length; i++) {
          this.ScheduleArray.push({
            ServiceID: data[i][0],
            // OutcomeID: data[i][1],
            Type: data[i][2],
            Category: data[i][3],
            ServiceNote: data[i][4],
            EndpointType: data[i][5],
            EndpointID: data[i][6],
            Location: data[i][7],
            PositionDesc: data[i][8],
            LocationNote: data[i][9],
            ArrangedBy: data[i][10],
            ScheduledDate: data[i][11],
            ScheduledTime: data[i][12],
            AssignedTo: data[i][13],
            Status: data[i][14],
            DeptFloor: data[i][15],
          });
        }
        // this.refreshTable();
      });
  },
  methods: {
    showaddAppointment() {
      this.$refs["addappointmentmodal"].show();
    },
    showeditAppointment(item) {
      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        ServiceID: item[0],
        Type: item[1],
        Category: item[2],
        ServiceNote: item[3],
        Area: item[4],
        LocationNote: item[5],
        ArrangedBy: item[6],
        Date: item[7],
        Time: item[8],
      };
      this.Action = "Edit";
      this.$refs["modifyappointmentmodal"].show(
        this.Action,
        this.ModifiedBooking
      );
    },
    showdeleteAppointment(item) {
      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        ServiceID: item[0],
        Type: item[1],
        Category: item[2],
        ServiceNote: item[3],
        Area: item[4],
        LocationNote: item[5],
        ArrangedBy: item[6],
        Date: item[7],
        Time: item[8],
      };
      this.Action = "Delete";
      this.$refs["modifyappointmentmodal"].show(
        this.Action,
        this.ModifiedBooking
      );
    },
    saveNewAppointment() {
      if (this.AppointmentType == null) {
        alert("Please select appointment type and complete all fields");
      } else if (
        this.newBooking.Name == null ||
        this.newBooking.Name == "" ||
        this.newBooking.Email == null ||
        this.newBooking.Email == "" ||
        this.newBooking.Date == null ||
        this.newBooking.Time == null
      ) {
        alert("Please complete all fields to submit booking");
      } else if (
        this.AppointmentType == "C-1 Service" ||
        this.AppointmentType == "C-1 Incident"
      ) {
        if (this.newBooking.Type == null) {
          alert("Please select Action Type");
        } else {
          alert("Save C-1");
          this.newBooking.Category = "Clarence";
          this.newBooking.TestType = "C-1";
        }
      } else if (
        this.AppointmentType == "O-1 Service" ||
        this.AppointmentType == "O-1 Incident"
      ) {
        if (this.newBooking.Type == null) {
          alert("Please select Action Type");
        } else {
          alert("Save O-1");
          this.newBooking.Category = "Clarence";
          this.newBooking.TestType = "O-1";
        }
      } else if (
        this.AppointmentType == "Washbasin Service" ||
        this.AppointmentType == "Washbasin Incident"
      ) {
        if (this.newBooking.Type == null) {
          alert("Please select Action Type");
        } else {
          alert("Save Washbasin");
          this.newBooking.Category = "Washbasin";
        }
      } else if (this.AppointmentType == "Water Testing") {
        if (this.newBooking.TestType == null || this.newBooking.Type == null) {
          alert("Please select Test Types");
        } else {
          alert("Save Test");
          this.newBooking.Category = "WMS";
        }
      } else if (this.AppointmentType == "Risk Assessment") {
        if (this.newBooking.CheckType == null || this.newBooking.Type == null) {
          alert("Please select Risk Assessment Types");
        } else {
          alert("Save Risk Assess");
          this.newBooking.Category = "WMS";
        }
      } else if (this.AppointmentType == "Manual Temp Check") {
        if (
          this.newBooking.NoOfOutlets == null ||
          this.newBooking.NoOfOutlets == ""
        ) {
          alert("Please select how many outlets");
        } else {
          alert("Save Manual Temp");
          this.newBooking.Category = "WMS";
          this.newBooking.Type = "Manual Temp";
        }
      } else if (
        this.AppointmentType == "Shower Head Installation" ||
        this.AppointmentType == "Filter Installation"
      ) {
        if (
          this.newBooking.TestType == null ||
          this.newBooking.NoOfOutlets == null ||
          this.newBooking.NoOfOutlets == ""
        ) {
          alert("Please select type and no of outlets");
        } else {
          alert("Save Filters");
          this.newBooking.Category = "WMS";
        }
      }
    },
    clearNewAppointment() {
      (this.AppointmentType = null),
        (this.newBooking = {
          Room: null,
          Note: null,
          CheckType: null,
          Name: null,
          Type: null,
          Date: null,
          Email: null,
          TestType: null,
          NoOfOutlets: null,
        });
    },
    cancelNewAppointment() {
      (this.AppointmentType = null),
        (this.newBooking = {
          Room: null,
          Note: null,
          CheckType: null,
          Name: null,
          Type: null,
          Date: null,
          Email: null,
          TestType: null,
          NoOfOutlets: null,
        }),
        this.$refs["addappointmentmodal"].hide();
    },
    saveEditAppointment() {
      alert("save edit");
    },
    cancelEditAppointment() {
      this.$refs["modifyappointmentmodal"].hide();
    },
    deleteAppointment(id) {
      alert("delete appointment " + id);
    },
  },
};
</script>
<style></style>
